if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");

        if (this.formInput) {
          this.formInput.disabled = false;
        }

        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset?.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.body;

        if (
          this.cart &&
          this.submitButton &&
          typeof this.cart.setActiveElement === "function"
        ) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton =
          this.disableLoadingInButton.bind(this);

        if (this.form) {
          this.form.addEventListener(
            "submit",
            this.onSubmitHandler.bind(this)
          );
        }
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay"
        );

        if (
          this.body?.classList.contains(
            "quick-buy-page-overlay"
          )
        ) {
          this.body.classList.remove(
            "quick-buy-page-overlay"
          );
        }

        if (
          complementaryOverlayPage?.classList.contains(
            "wt__quick-buy--page-overlay--open"
          )
        ) {
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open"
          );
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form || !this.submitButton) {
          return;
        }

        if (
          this.submitButton.getAttribute(
            "aria-disabled"
          ) === "true"
        ) {
          return;
        }

        this.handleErrorMessage();

        if (
          this.cart &&
          typeof this.cart.setActiveElement ===
            "function"
        ) {
          this.cart.setActiveElement(
            document.activeElement
          );
        }

        const loader = this.querySelector(
          ".loading-overlay__spinner"
        );

        this.submitButton.setAttribute(
          "aria-disabled",
          "true"
        );

        this.submitButton.classList.add("loading");

        if (loader) {
          loader.classList.remove("hidden");
        }

        const config =
          typeof fetchConfig === "function"
            ? fetchConfig("javascript")
            : {
                method: "POST",
                headers: {
                  Accept: "application/json",
                },
              };

        config.headers = config.headers || {};

        config.headers["X-Requested-With"] =
          "XMLHttpRequest";

        /*
         * Let FormData set the multipart boundary itself.
         */
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        /*
         * Only add cart drawer section data if
         * cart-drawer exists and supports it.
         *
         * This avoids the crash from:
         * this.cart.getSectionsToRender()
         */
        if (
          this.cart &&
          typeof this.cart.getSectionsToRender ===
            "function"
        ) {
          const sections = this.cart
            .getSectionsToRender()
            .map((section) => section?.id)
            .filter(Boolean);

          if (sections.length) {
            formData.append(
              "sections",
              sections.join(",")
            );

            formData.append(
              "sections_url",
              window.location.pathname
            );
          }
        }

        config.body = formData;

        const cartAddUrl =
          (typeof routes !== "undefined" &&
            routes.cart_add_url) ||
          window.routes?.cart_add_url ||
          "/cart/add.js";

        fetch(cartAddUrl, config)
          .then(async (response) => {
            let data;

            try {
              data = await response.json();
            } catch (error) {
              throw new Error(
                `Cart response was not valid JSON (${response.status}).`
              );
            }

            if (!response.ok && !data?.status) {
              data.status = response.status;
            }

            return data;
          })
          .then((response) => {
            if (response.status) {
              if (
                typeof publish === "function" &&
                typeof PUB_SUB_EVENTS !==
                  "undefined"
              ) {
                publish(
                  PUB_SUB_EVENTS.cartError,
                  {
                    source: "product-form",
                    productVariantId:
                      formData.get("id"),
                    errors:
                      response.errors ||
                      response.description ||
                      response.message,
                    message: response.message,
                  }
                );
              }

              this.handleErrorMessage(
                response.description ||
                  response.message ||
                  "This product could not be added to your cart."
              );

              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(
                  ".sold-out-message"
                );

              if (soldOutMessage) {
                this.submitButton.setAttribute(
                  "aria-disabled",
                  "true"
                );

                this.submitButton
                  .querySelector("span")
                  ?.classList.add("hidden");

                soldOutMessage.classList.remove(
                  "hidden"
                );
              }

              return;
            }

            if (
              typeof publish === "function" &&
              typeof PUB_SUB_EVENTS !==
                "undefined"
            ) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: "product-form",
                  productVariantId:
                    formData.get("id"),
                  cartData: response,
                }
              );
            }

            this.error = false;

            const quickAddModal =
              this.closest("quick-add-modal");

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(
                      response
                    );
                  });
                },
                { once: true }
              );

              if (
                this.cartType === "drawer" &&
                typeof quickAddModal.hide ===
                  "function"
              ) {
                quickAddModal.hide(true);
              } else {
                this.redirectAfterSubmit(
                  response
                );
              }

              return;
            }

            const isClosedCart =
              !document.body.classList.contains(
                "page-overlay-cart-on"
              );

            this.redirectAfterSubmit(
              response,
              isClosedCart
            );
          })
          .catch((error) => {
            console.error(
              "Third Culture Kat add-to-cart error:",
              error
            );

            this.handleErrorMessage(
              "Something went wrong while adding this product. Please try again."
            );

            this.error = true;
          })
          .finally(() => {
            this.disableLoadingInButton();

            if (
              this.cart &&
              this.cart.classList.contains(
                "is-empty"
              )
            ) {
              this.cart.classList.remove(
                "is-empty"
              );
            }

            if (!this.error) {
              this.submitButton?.removeAttribute(
                "aria-disabled"
              );
            }

            const quickAddContainer =
              document.querySelector(
                ".wt__quick-buy__container"
              );

            const quickAddOverlay =
              document.querySelector(
                ".wt__quick-buy--page-overlay"
              );

            if (
              quickAddContainer &&
              !quickAddContainer.classList.contains(
                "hidden"
              )
            ) {
              const quickAddProduct =
                quickAddContainer.querySelector(
                  ".wt-product"
                );

              const quickAddLoader =
                quickAddContainer.querySelector(
                  ".wt__quick-buy-loader"
                );

              quickAddProduct?.remove();

              quickAddContainer.classList.remove(
                "wt__quick-buy__container--open"
              );

              quickAddOverlay?.classList.remove(
                "wt__quick-buy--page-overlay--open"
              );

              document.body.classList.remove(
                "quick-buy-page-overlay"
              );

              quickAddLoader?.classList.remove(
                "hidden"
              );
            }
          });
      }

      disableLoadingInButton() {
        this.submitButton?.classList.remove(
          "loading"
        );

        const spinner = this.querySelector(
          ".loading-overlay__spinner"
        );

        spinner?.classList.add("hidden");
      }

      redirectAfterSubmit(
        response,
        isClosedCart = true
      ) {
        const body = document.body;

        const isCartPage =
          body.classList.contains(
            "template-cart"
          );

        if (
          this.cartType === "drawer" &&
          isCartPage
        ) {
          const overlay =
            document.querySelector(
              ".wt__quick-buy--page-overlay"
            );

          overlay?.classList.remove(
            "wt__quick-buy--page-overlay--open"
          );

          body.classList.remove(
            "quick-buy-page-overlay"
          );
        } else if (
          this.cartType === "drawer" &&
          this.cart &&
          typeof this.cart.renderContents ===
            "function" &&
          response?.sections
        ) {
          this.cart.renderContents(
            response,
            isClosedCart
          );

          return;
        }

        const cartUrl =
          (typeof routes !== "undefined" &&
            routes.cart_url) ||
          window.routes?.cart_url ||
          "/cart";

        window.location.href = cartUrl;
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            ".product-form__error-message-wrapper"
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute(
          "hidden",
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}